import { useAuth } from 'hooks';
import { QueryKeys } from 'queries';
import { useQuery, UseQueryOptions } from 'react-query';

import apiService from 'services/api/ApiService';
import { LeaderBoards } from 'services/api/definitions/game.definitions';

export const useLeaderboard = (
  id: string,
  options: UseQueryOptions<LeaderBoards> = { enabled: true },
) => {
  const { isLoggedIn } = useAuth();

  const { data, isLoading } = useQuery(
    QueryKeys.allgames.leaderboard(id),
    () => apiService.getGameLeaderboards(id),
    {
      ...options,
      enabled: isLoggedIn && options.enabled,
    },
  );

  return {
    isLoading,
    leaderboards: data,
  };
};
